<template>
<nav id="sidebar" class="d-none d-md-none d-lg-block" :class="this.sidemenu_minimized">
    <div class="sidebar-header">
    <div @click="toggleToIcons()" style="margin-top: 65px; margin-left: 5px;">
        <i class="fa fa-bars fa-1x"></i>
        <span class="menu-item-name app-heading">Mentoring</span></div>
    </div>
   <ul class="list-unstyled">
     <li class="active" >
         <router-link :to="url">
         <i class="fa fa-home"></i>
         <span class="menu-item-name">Home</span>
         </router-link>
     </li>
     <li v-if="$store.state.school_flag === true || $store.state.switch_admin_account_flag === true">
         <router-link to="/add-instructor" >
           <i class="fa fa-user-plus"></i>
           <span class="menu-item-name">Add Instructor</span>
         </router-link>
     </li>
     <li v-else>
         <router-link to="/add-mentor" >
           <i class="fa fa-user-plus"></i>
           <span class="menu-item-name">Add Mentor</span>
         </router-link>
     </li>
     <li v-if="$store.state.school_flag === true || $store.state.switch_admin_account_flag === true">
         <router-link to="/add-student" >
           <i class="fa fa-child"></i>
           <span class="menu-item-name">Add Student</span>
         </router-link>
     </li>
     <li v-else>
         <router-link to="/add-mentee" >
           <i class="fa fa-child"></i>
           <span class="menu-item-name">Add Mentee</span>
         </router-link>
     </li>
     <li v-if="$store.state.school_flag != true || $store.state.switch_admin_account_flag != true">
        <router-link to="/add-apprentice" >
           <i class="fa fa-child"></i>
           <span class="menu-item-name">Add Apprentice</span>
         </router-link>
      </li>
     <li v-if="$store.state.school_flag === true || $store.state.switch_admin_account_flag === true">
         <router-link to="/add-group" >
           <i class="fa fa-users"></i>
           <span class="menu-item-name">Add Group</span>
         </router-link>
     </li>
     <!-- <li>
        <router-link to="/view-tasklist" >
        <i class="fa fa-tasks"></i>
        <span class="menu-item-name">Task Lists</span>
        </router-link>
     </li>
     <li>
         <router-link to="/task-library" >
         <i class="fa fa-book"></i>
         <span class="menu-item-name">Task Library</span>
         </router-link>
     </li> -->
  </ul>

    <ul class="list-unstyled list-signout-menu">
      <li>
      <router-link to="/logout">
      <i class="fa fa-sign-out"></i>
      <span class="menu-item-name">Sign Out</span>
      </router-link>
      </li>
   </ul>
</nav>
</template>

<script>
import store from '../../store/store.js';

export default {
  data() {
    return {
      activeClass: 'nav-active',
      sidemenu_minimized: '',
      url: '',
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
   toggleToIcons() {
     document.getElementById('sidebar').classList.toggle("active");
     let minimized = '';
     if(document.getElementById('sidebar').classList == 'active')
     {
        minimized = 'active';
     }
     this.$store.dispatch('sidebar_menu_minimized', minimized);
   }
  },
  created() {
    this.sidemenu_minimized = this.$store.state.sidebar_menu_minimized;
    var roles = this.$store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      if((this.$store.state.school_flag == 1) || (this.$store.state.switch_admin_account_flag == 1)) {
        this.url = '/school-admin-dashboard';
      }
      else {
        this.url = '/company-admin-dashboard';
      }
    }
  }
}
</script>

<style>
.heading-seperator {
  border-bottom: 2px solid #00ACEE;
  margin: 10px 10px 0px 10px;
}
.heading {
  font-size: 15px;
  padding-left: 20px;
}
#sidebar {
    min-width: 250px;
    max-width: 250px;
    background-color: #D4D4D4;
    min-height: 100vh;
    transition: opacity 2s linear;
    transform:translate(0);
    opacity: 1;
}
#sidebar.active {
    min-width: 60px;
    max-width: 60px;
    text-align: center;
}
#sidebar.active .menu-item-name {
   display: none;
}
#sidebar.active .sidebar-header h3 {
    display: none;
}

#sidebar.active .sidebar-header strong {
    display: block;
}

#sidebar ul li a {
    text-align: left;
    text-decoration: none;
}

#sidebar.active ul li a {
    padding: 0px 10px;
    text-align: center;
    font-size: 0.85em;
    text-decoration: none;
}

#sidebar.active ul li a i {
    margin-right: 0;
    display: block;
    font-size: 16px;
}

#sidebar.active ul ul a {
    padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
}

#sidebar .sidebar-header {
    padding: 0px 10px 10px 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

#sidebar ul.components {
    padding: 5px 0;
    border-bottom: 1px solid #00ACEE;
}
#sidebar ul li a {
    padding: 0px 10px 0px 10px;
    display: block;
    color: #212529;
    margin-left: 5px;
}
#sidebar ul ul li a {
    padding: 2px;
}
#sidebar ul li a i {
    margin-right: 10px;
}
#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"] {
    color: #212529;
}
a[data-toggle="collapse"] {
    position: relative;
}
.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
.app-heading {
 margin-left: 10px;
}
.list-signout-menu {
  bottom: 0px;
  position: absolute;
}
.report-dropdown {
  float: right;
  font-size: 20px;
}
#sidebar.active ul ul {
  display: none;
}
#sidebar ul li {
  padding-top: 10px;
  padding-bottom: 10px;
}
#sidebar ul li a.nav-active, #sidebar ul li a.router-link-exact-active {
  border-left: 3px solid #00ACEE;
  margin-left: 2px;
}
#sidebar ul li a i {
  width: 15px;
}
#sidebar.active ul li a i {
  width: 35px;
}
#collapse-report-submenu ul li {
  padding-top: 0px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/admin_sidebar_menu.vue